import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl'
import $ from 'jquery'
import ActionButton from "../common/button/actionbutton.component.jsx";


const messages = defineMessages({
    "notes_placeholder": {
        id: 'project.internal_notes_modal.notes_placeholder',
        defaultMessage: 'Write a notes only the staff will see...',
    },
})

class InternalNotesModal extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            selectedOption: null,
            notes: this.props.notes || '',
            projectId: this.props.projectId,
            noteId: this.props.noteId,
        }

        this.onClose = this.props.onClose
        this.onSubmit = this.props.onSubmit
        this.handleFormChange = this.handleFormChange.bind(this)
        this.closeModals = this.closeModals.bind(this)
        this.submit = this.submit.bind(this)
    }

    componentDidMount() {
        $('#internalNotesModal').modal('show')
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            notes: nextProps.notes || '',
            projectId: nextProps.projectId || '',
            noteId: nextProps.noteId || '',
        })
    }

    submit(event) {
        event.preventDefault()
        let endPoint = '/projects/' + this.state.projectId + '/internal-notes'
        const data = {
            notes: this.state.notes,
        }
        if (this.state.noteId) {
            endPoint += '/' + this.state.noteId
            return AppContext.getApiClient().put(endPoint, data).then(q => {
                $('#internalNotesModal').modal('hide')
                this.onSubmit(q)
            })
        }
        return AppContext.getApiClient().post(endPoint, data).then(q => {
            $('#internalNotesModal').modal('hide')
            this.onSubmit(q)
        })
    }

    closeModals(event, response) {
        event.preventDefault()
        $('#internalNotesModal').modal('hide')
        this.onClose(response)
    }

    handleFormChange(event) {
        const target = event.target;
        this.setState({
            [target.name]: target.value
        })
    }

    render() {

        return (
            <div>
                {/************** Discount quote Modal ***************/}
                <div className="modal fade"
                    id="internalNotesModal"
                    role="dialog"
                    aria-hidden="true"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title pb-0 mb-0 border-0" id="internalNotesModal">
                                    <FormattedMessage
                                        id="project.internal_notes_modal.title"
                                        defaultMessage="Write internal notes"
                                    />
                                </h5>
                                <button type="button" className="close" onClick={this.closeModals} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="container-fluid">
                                    <div className="form-group row mb-3">
                                        <div className="col-12">
                                            <textarea
                                                className="form-control"
                                                id="notes"
                                                name="notes"
                                                value={this.state.notes}
                                                onChange={this.handleFormChange}
                                                rows={5}
                                                placeholder={this.props.intl.formatMessage(messages["notes_placeholder"])}
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={this.closeModals}>
                                    <FormattedMessage
                                        id="project.internal_notes_modal.close_btn"
                                        defaultMessage="Close"
                                    />
                                </button>
                                <ActionButton disabled={!this.state.notes} type="button" className="btn btn-primary" onClick={this.submit}>
                                    <FormattedMessage
                                        id="project.internal_notes_modal.submit_btn"
                                        defaultMessage="Submit"
                                    />
                                </ActionButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(InternalNotesModal)





// WEBPACK FOOTER //
// ./src/project/internalnotesmodal.component.jsx